import { PRODUCTS_API, request } from './api';
export async function adminRequest(path, options = {}) {
  const { auth } = await import('./auth');
  if (!auth.currentUser) throw new Error('Iniciá sesión como administrador.');
  const token = await auth.currentUser.getIdToken();
  return request(`${PRODUCTS_API}${path}`, { ...options,
    headers: { ...options.headers, Authorization: `Bearer ${token}` } });
}
